var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pmRight",staticClass:"pm-right"},[_c('canvas',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"canvas-arch"}})])}
var staticRenderFns = []

export { render, staticRenderFns }